<template>
  <div>
    <div class="row" style="background-color: #f7f7fc; padding: 10px 0px; border-top-left-radius: 1rem; border-top-right-radius: 1rem;">
      <div class="col-sm-12">
        <div class="input-group" style="height: 85%; width: 93%; float: left;">
          <input id="filter-text-box" v-model="searchTerm" data-test="filter-text-box" type="text" :placeholder="$t('search-moderated-users')" class="form-control border-0 shadow-sm" @input="onFilterTextBoxChanged()">
          <span class="input-group-text border-0 shadow-sm"><i class="fa fa-search"></i></span>
        </div>
        <span class="text-primary" style="cursor: pointer; float: right; width: 5%; padding-top: 9px;" @click="refreshFilterTextBox()">{{ $t('clear-search') }}</span>
      </div>
    </div>
    <b-overlay :show="busy" rounded="sm">
      <ag-grid-vue
        style="width: 100%; height: 500px; font-family: 'Nunito', sans-serif;"
        class="ag-theme-alpine text-center"
        rowSelection="single"
        :gridOptions="gridOptions"
        :frameworkComponents="frameworkComponents"
        :columnDefs="columnDefs"
        :pagination="true"
        paginationPageSize="30"
        :rowData="sortedArray(filteredModeratedMembers).reverse()"
        @grid-ready="onGridReady"
      ></ag-grid-vue>
    </b-overlay>
    <b-modal v-model="showNotesModal" hide-footer hide-header no-close-on-esc no-close-on-backdrop size="lg">
      <span role="button" class="close float-end fs-4 mt-n2 me-n1" @click.prevent="showNotesModal = false, selectedRequest = null, requestNote = ''">
        <span aria-hidden="true"><i class="fa fa-times"></i></span>
      </span>
      <div class="row mb-4">
      <h5>Add or update your notes for this request.</h5>
        <div class="col">
          <textarea
            id="request_note"
            v-model="requestNote"
            data-test="request_note"
            class="form-control"
            rows="5"
            placeholder="Enter your note"
          ></textarea>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col text-center">
          <button
            id="btn_request_note_submit"
            class="btn btn-primary"
            data-test="btn_request_note_submit"
            @click="addNote(selectedRequest, requestNote)"
          >
            {{ $t('network.user.save') }}
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import BtnApproveModeration from './BtnApproveModeration.js';
import BtnRejectModeration from './BtnRejectModeration.js';
import BtnAddNoteModeration from './BtnAddNoteModeration.js';
import sortBy from 'lodash/sortBy';
import '@/lib/ag-grid';

export default {
  props: {
    network: {
      type: Object,
      default: null,
    },
    filteredMembers: {
      type: Array,
      default: null,
    },
    isModerator: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inviteMessage: '',
      moderatedMembers: [],
      filteredModeratedMembers: [],
      loadingInvites: true,
      processingResend: false,
      selectedModerationStatus: this.$t('ModerationTab.pending'),
      moderationStatuses: [this.$t('ModerationTab.pending'), this.$t('ModerationTab.approved'), this.$t('ModerationTab.rejected')],
      gridOptions: null,
      frameworkComponents: null,
      columnDefs: null,
      rowData: null,
      selectedRows: [],
      searchTerm: '',
      selectedRequest: null,
      showNotesModal: false,
      requestNote: '',
    };
  },
  computed: {
    busy() {
      return this.processingResend || this.loadingInvites;
    },
  },
  watch: {
    filteredMembers: {
      handler(newV) {
        this.filteredModeratedMembers = newV;
      },
    },
  },
  beforeMount() {
    this.gridOptions = {
      defaultColDef: {
        width: 150,
        resizable: true,
        floatingFilter: true,
      },

      components: {
        booleanCellRenderer: function(params) {
          if (params.value === true) {
            return "<span title='true' class='fas text-success fa-check'></span>";
          } else if (params.value === false) {
            return "<span title='false' class='fas text-danger fa-times'></span>";
          } else if (params.value !== null && params.value !== undefined) {
            return params.value.toString();
          } else {
            return null;
          }
        },
      },
    };
    this.onGridReady = () => {
      let filters = document.querySelectorAll('.ag-input-field-input');
      filters.forEach(filter => {
        filter.placeholder = this.$t('network.search');
      });
    };
    this.frameworkComponents = {
      btnApproveCellRenderer: BtnApproveModeration,
      btnRejectCellRenderer: BtnRejectModeration,
      btnNoteCellRenderer: BtnAddNoteModeration,
    };

    this.columnDefs = [
      {
        sortable: true,
        filter: true,
        filterParams: {
          filterOptions: ['contains'],
          suppressAndOrCondition: true,
          buttons: ['clear'],
        },
        headerName: this.$t('network.name'),
        headerComponentParams: {
          template:
          '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
            '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
            '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
            '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
            '    <i class="fas fa-user"></i>&nbsp;<span ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
            '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
          '</div>'
        },
        field: 'user.fullname',
        minWidth: 150,
        flex: 1,
      },
      {
        sortable: true,
        filter: true,
        filterParams: {
          filterOptions: ['contains'],
          suppressAndOrCondition: true,
          buttons: ['clear'],
        },
        headerName: this.$t('network.auth.email'),
        headerComponentParams: {
          template:
          '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
            '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
            '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
            '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
            '    <i class="fas fa-at"></i>&nbsp;<span ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
            '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
          '</div>'
        },
        field: 'user.email',
        cellRenderer: (field) => {
          return `<a href="mailto:${field.value}">${field.value}</a>`;
        },
        minWidth: 200,
        flex: 1,
      },
      {
        sortable: true,
        filter: true,
        filterParams: {
          filterOptions: ['contains'],
          suppressAndOrCondition: true,
          buttons: ['clear'],
        },
        headerName: this.$t('network.auth.nameSuffix'),
        headerComponentParams: {
          template:
          '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
            '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
            '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
            '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
            '    <i class="fas fa-diploma"></i>&nbsp;<span ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
            '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
          '</div>'
        },
        field: 'user.name_suffix',
        minWidth: 100,
        flex: 1,
      },
      {
        sortable: true,
        filter: true,
        filterParams: {
          filterOptions: ['contains'],
          suppressAndOrCondition: true,
          buttons: ['clear'],
        },
        headerName: this.$t('job-title'),
        headerComponentParams: {
          template:
          '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
            '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
            '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
            '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
            '    <i class="fas fa-user-nurse"></i>&nbsp;<span ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
            '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
          '</div>'
        },
        field: 'user.rpc_user_workinfo.job_title',
        minWidth: 200,
        flex: 1,
      },
      {
        sortable: true,
        filter: true,
        filterParams: {
          filterOptions: ['contains'],
          suppressAndOrCondition: true,
          buttons: ['clear'],
        },
        headerName: this.$t('workplace'),
        headerComponentParams: {
          template:
          '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
            '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
            '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
            '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
            '    <i class="fas fa-briefcase"></i>&nbsp;<span ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
            '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
          '</div>'
        },
        field: 'user.rpc_user_workinfo.workplace',
        minWidth: 250,
        flex: 1,
      },
      {
        sortable: true,
        headerName: this.$t('ModerationTab.requested-at'),
        headerComponentParams: {
          template:
          '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
            '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
            '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
            '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
            '    <i class="fas fa-calendar-day"></i>&nbsp;<span ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
            '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
          '</div>'
        },
        field: 'created_at',
        filter:'agDateColumnFilter',
        filterParams: {
          comparator:function (filterLocalDateAtMidnight, cellValue) {console.log('cellValue',cellValue);
            var dateAsString = cellValue.split("T");
            if (dateAsString == null) return -1;
            var dateParts  = dateAsString[0].split("-");
            var cellDate = new Date(Number(dateParts[0]), Number(dateParts[1]) - 1, Number(dateParts[2]));

            if (filterLocalDateAtMidnight.getTime() == cellDate.getTime()) {
              return 0
            }

            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            }

            if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            }
          },
          browserDatePicker: true,
          suppressAndOrCondition: true,
          buttons: ['clear'],
        },
        cellRenderer: (field) => {
          return this.formatDate(field.value);
        },
        minWidth: 200,
        flex: 1,
      },
      {
        sortable: true,
        filter: true,
        filterParams: {
          filterOptions: ['contains'],
          suppressAndOrCondition: true,
          buttons: ['clear'],
        },
        headerName: this.$t('network.member.status'),
        headerComponentParams: {
          template:
          '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
            '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
            '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
            '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
            '    <i class="fas fa-user-clock"></i>&nbsp;<span ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
            '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
          '</div>'
        },
        field: 'moderation_status',
        minWidth: 100,
        flex: 1,
      },
      {
        headerName: this.$t('Nav.profile'),
        headerComponentParams: {
          template:
          '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
            '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
            '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
            '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
            '    <i class="fas fa-external-link-alt"></i>&nbsp;<span ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
            '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
          '</div>'
        },
        field: 'user_id',
        cellRenderer: (field) => {
          return `<a href="https://networks.resonancehealth.org/admin/resources/users/${field.value}" target="_blank"
          class="text-primary fw-semibold fs-5">View Account</a>`;
        },
        minWidth: 100,
        flex: 1
      },
      {
        headerName: this.$t('network.member.message'),
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
            '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
            '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
            '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
            '    <i class="fas fa-envelope"></i>&nbsp;<span ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
            '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        },
        field: 'user.email',
        cellRenderer: (field) => {
          const link = document.createElement('a');
          link.href = `mailto:${field.value}`;
          link.innerHTML = `<span class="text-primary fw-semibold fs-5">${this.$t('network.member.message')}</span>`;
          link.addEventListener('click', (event) => {
            event.stopPropagation();
            window.open(link.href, '_blank');
          });
          return link.outerHTML;
        },
        minWidth: 100,
        flex: 1,
      },
      {
        headerName: this.$t('ModerationTab.approve'),
        headerComponentParams: {
          template:
          '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
            '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
            '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
            '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
            '    <i class="fas fa-thumbs-up"></i>&nbsp;<span ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
            '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
          '</div>'
        },
        field: 'Approve',
        cellRenderer: 'btnApproveCellRenderer',
        cellRendererParams: {
          clicked: field => {
            this.approveModeration(field);
          },
        },
      },
      {
        headerName: this.$t('ModerationTab.reject'),
        headerComponentParams: {
          template:
          '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
            '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
            '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
            '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
            '    <i class="fas fa-thumbs-down"></i>&nbsp;<span ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
            '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
          '</div>'
        },
        field: 'Reject',
        cellRenderer: 'btnRejectCellRenderer',
        cellRendererParams: {
          clicked: field => {
            this.rejectModeration(field);
          },
        },
      },
      {
        sortable: true,
        filter: true,
        filterParams: {
          filterOptions: ['contains'],
          suppressAndOrCondition: true,
          buttons: ['clear'],
        },
        headerName: 'Notes',
        headerComponentParams: {
          template:
          '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
            '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
            '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
            '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
            '    <i class="fa-solid fa-note"></i>&nbsp;<span ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
            '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
          '</div>'
        },
        field: 'notes',
        cellRenderer: 'btnNoteCellRenderer',
        cellRendererParams: {
          clicked: field => {
            this.showModal(field);
          },
        },
      },
    ];
  },
  mounted() {
    this.load();
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
  methods: {
    boolIconFormatter(v) {
      return v ? '<span  class="ml-5 badge badge-success"><i class="fa fa-check" /> Check</span>' : '';
      //<span lass="ml-5 badge badge-danger">Declined</span>
    },
    load() {
      this.loadingInvites = true;
      this.$http
        .get('networks/' + this.network.slug + '/moderations', {
          params: this.pagination,
        })
        .then(resp => {
          this.loadingInvites = false;
          this.moderatedMembers = resp.data;
          this.filteredModeratedMembers = this.filteredMembers != null ? this.filteredMembers : resp.data.filter(m => m.user.email_verified_at != null);
        });
    },
    formatDate(date) {
      date = new Date(date);
      return ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) + '-' + date.getFullYear();
    },
    sortedArray(array) {
      return sortBy(array, 'created_at');
    },
    onFilterTextBoxChanged() {
      this.gridApi.setQuickFilter(
        document.getElementById('filter-text-box').value
      );
    },
    refreshFilterTextBox() {
      this.searchTerm = '';
      this.gridApi.setQuickFilter(
        document.getElementById('filter-text-box').textContent = ''
      );
    },
    approveModeration(member) {
      if (this.isModerator) {
        this.$http
          .post('networks/' + this.network.slug + '/approve-moderation', {
            member: member,
          })
          .then(resp => {
            var msg = '';
            if (resp) {
              msg = this.$t('network.join.user_added_to_network', {
                defaultValue: '{{ userFullName }} has been approved and added to the network',
                userFullName: member.user.fullname,
              });
            } else {
              msg = this.$t('network.join.failed_adding_user_to_network', {
                defaultValue: 'Failed to add {{ userFullName }}, please try again.',
                userFullName: member.user.fullname,
              });
            }
            this.$bvModal.msgBoxOk(msg);
            this.load(); // load moderation requests again
          })
          .catch(() => {
            this.$bvModal.msgBoxOk(this.$t('network.member.somethingWentWrong'));
          });
      } else {
        this.$swal.fire({
          icon: 'error',
          title: "You don't have the permissions to do this.",
        });
      }
    },
    rejectModeration(member) {
      if (this.isModerator) {
        this.$http
          .post('networks/' + this.network.slug + '/reject-moderation', {
            member: member,
          })
          .then(resp => {
            var msg = '';
            if (resp) {
              msg = `${member.user.fullname} is removed from the network`;
            } else {
              msg = `failed to remove ${member.user.fullname}, please try again`;
            }
            this.$bvModal.msgBoxOk(msg);
            this.load(); // load moderation requests again
          })
          .catch(() => {
            this.$bvModal.msgBoxOk(this.$t('network.member.somethingWentWrong'));
          });
      } else {
        this.$swal.fire({
          icon: 'error',
          title: "You don't have the permissions to do this.",
        });
      }
    },
    showModal(request) {
      this.showNotesModal = true;
      this.selectedRequest = request;
      if (request.notes !== null || request.notes !== '') {
        this.requestNote = request.notes;
      }
    },
    addNote(request, note) {
      this.$http.post('networks/' + this.network.slug + '/moderations/add-notes', { request_id: request.id, notes: note }).then(() => {
        this.showNotesModal = false;
        this.selectedRequest = null;
        this.requestNote = '';
        this.$swal.fire({
          text: 'Notes updated successfully!',
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 1500,
          timerProgressBar: true,
        });
        this.load(); // load moderation requests again
      });
    },
  },
};
</script>
<style>
.ag-header-cell-label {
  justify-content: center;
  font-size: 19px;
  font-weight: 600;
  color: #5c6d80;
}
.ag-theme-alpine .ag-row {
  font-size: 15px;
}
</style>
